module Client.Page.NotAllowed

open Fulma
open Fable.React

let view =
    Heading.h1 [
        Heading.Modifiers [
            Modifier.TextAlignment(Screen.All, TextAlignment.Centered)
        ]
    ] [ str "Du darfst diese Seite nicht aufrufen" ]